import { Box, CircularProgress } from '@mui/material';
import { useAppDispatch } from '@redux/hooks';
import { logoutUser } from '@redux/reducers/user.reducer';
import { setLocale, detectDeviceLocale } from '@redux/reducers/locale.reducer';
import React, { useEffect } from 'react';

const LogoutPage: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Sprint 28, story-143, Decision 4 (docs/architecture.md "## Sprint 28"). `logout` is Bucket
    // 1 (pre-auth, device/browser-detected) reached from a Bucket-2-adjacent path — reset
    // `activeLocale` to a fresh detection as part of the same session-clearing sequence, so this
    // page (and whatever renders next) doesn't inherit the just-logged-out user's chosen locale.
    //
    // Sprint 28, develop run 3 (story-143 review Warning #1 fix): `logoutUser()` must dispatch
    // FIRST. The root reducer (`@redux/index.ts`) intercepts `LOGOUT_USER` and resets every
    // slice — including `locale` — back to `localeReducer`'s `localeInitialState`, which is
    // computed once at module load (app boot), not re-evaluated on this reset. Dispatching
    // `setLocale(detectDeviceLocale())` before `logoutUser()` meant the full-state reset silently
    // discarded it one line later; dispatching it after makes the fresh detection the value that
    // actually survives into the next render.
    dispatch(logoutUser());
    dispatch(setLocale(detectDeviceLocale()));
  }, [dispatch]);

  return (
    <Box className="flex justify-center items-center h-full">
      <CircularProgress />
    </Box>
  );
};

export default LogoutPage;
